<ng-container *ngIf="!hasRenderedComponent;else renderedComponent">
    <ng-container *ngIf="hasSearchResults;else noSearchResult">
        <ubs-ofbiz-list 
            [fieldOptions]="fieldOptions" 
            [listOptions]="listOptions" 
            title="title" [state]="state$" 
            (overViewSelected)="showOverview($event)" 
            [searchResults]="result" 
            (editSelected)="showEditDialog($event)" 
            [columnFields]="columnFields"
            [columnFieldTitles]="columnFieldTitles"
            [remoteFormData]="remoteFormData">
        </ubs-ofbiz-list>
    </ng-container>
    <ng-template #noSearchResult>
        <ubs-ofbiz-list 
            [fieldOptions]="fieldOptions" 
            [listOptions]="listOptions" 
            title="title" 
            [state]="state$" 
            (overViewSelected)="showOverview($event)" 
            (editSelected)="showEditDialog($event)" 
            [columnFields]="columnFields"
            [columnFieldTitles]="columnFieldTitles"
            [remoteFormData]="remoteFormData" 
            (hyperlinkSelected)="handleHyperLinkSelected($event)"
            (listSuccessNotify) = "handleListSucessNotify($event)"
            [isLookup]="isLookup"
            [cardMode]="cardMode">
        </ubs-ofbiz-list>
    </ng-template>
</ng-container>
<ng-template #renderedComponent>
  <ubs-custom-list-container [renderComponent]="renderComponent" [remoteFormData]="remoteFormData" ></ubs-custom-list-container>
</ng-template>



